 <!-- websiteApproval -->
 <template>
    <!-- 官网注册审批 -->
    <div class="websiteApproval">
        <component :is="comList[active]" @changeteamInfoData="changeteamInfoData" :teamInfoData="teamInfoData" @changeActive="changeActive" :rowData="rowData" @changeRowData="changeRowData"></component>
    </div>
</template>

<script>
export default {
    name: 'websiteApproval',

    data() {
        return {
            active: 0,
            comList:["webHomePage", "addWebPage",  "teamInfo" ],
            rowData: {},
            teamInfoData: {}
        };
    },

    mounted() {
    },


    methods: {
        changeActive(val) {
            this.active = val
        },
        changeRowData(data) {
            this.rowData = data
        },
        changeteamInfoData(val) {
            this.teamInfoData = val
            console.log(val, 'VAL')
        }
    },
    components: {
        webHomePage: () => import('./components/webHomePage.vue'),
        addWebPage: () => import('./components/addWebPage.vue'),
        teamInfo: () => import('./components/teamInfo.vue')
    }
};
</script>

<style lang="scss" scoped>
.websiteApproval {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .search_container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding-left: 20px;
        box-sizing: border-box;
        .btnBox {
            width: 55%;
            text-align: right;
        }
    }
    .comPractice_container {
        width: 100%;
        height: 100%;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
    }
    .button_box {
        display: flex;
        height: 60px;
        justify-content: flex-end;
        align-items: center;
    }
    .searchBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /deep/.el-form-item {
            margin-bottom: 0;
        }
    }
    .mySelect {
        /deep/.el-select {
            /deep/.el-input {
                width: 100px;
            }
        }
    }
    .addPlanDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        .formcenter {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 10px;
            /deep/.el-form-item {
                margin-bottom: 0;
            }
        }
        /deep/.el-checkbox {
            display: flex;
            align-items: center;
        }
        // .formLeft {
        //     padding-left: 17px;
        //     box-sizing: border-box;
        // }
        .mechanism {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 15px;
        }
        .mechanism_center {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .arrow_left {
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                color: #fff;
                margin-bottom: 5px;
                background-color: #409eff;
                border-radius: 3px;
                cursor: pointer;
            }
            .arrow_right {
                width: 30px;
                height: 30px;
                color: #fff;
                margin-top: 5px;
                line-height: 30px;
                text-align: center;
                background-color: #409eff;
                border-radius: 3px;
                cursor: pointer;
            }
        }
        .mechanism_left {
            width: 45%;
            height: 350px;
            border: 1px solid #ccc;
        }
        .mechanism_right {
            width: 45%;
            height: 350px;
            border: 1px solid #ccc;
        }
        .mechanismToptitle {
            padding: 0 10px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 50px;
            line-height: 50px;
            border-bottom: 1px solid #ccc;
            .left_box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
            .right_box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
        }
        .mechanismBottomMin {
            width: 100%;
            height: calc(100% - 50px);
        }
        .mechanismSearch {
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
        .mechanismTable {
            padding: 0 10px 0px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: space-around;
            width: 100%;
            height: calc(100% - 40px);
            overflow-x: hidden;
        }
        .mechanismTable2 {
            padding: 0 10px 0px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: space-around;
            width: 100%;
            height: calc(100% - 40px);
            overflow-x: hidden;
        }
        .planInfo {
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            align-content: space-around;
            color: #409eff;
            .planInfo_top {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .left {
                    margin-right: 30px;
                }
            }
        }
        .mechanismOrgName {
            display: inline-block;
            width: 180px;
            height: 33px;
            line-height: 33px;
            overflow-x: hidden;
            overflow-y: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
        .selectText {
            display: inline-block;
            width: 62px;
            height: 33px;
            line-height: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
        .selectText2 {
            display: inline-block;
            width: 50px;
            height: 33px;
            line-height: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-top: 1px;
            box-sizing: border-box;
        }
    }
    .editDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding-left: 150px;
            padding-bottom: 0px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .editCenterTwoBox {
            display: flex;
            justify-content: flex-start;
        }
    }
    .accountDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .reason {
            margin-bottom: 10px;
            color: #409eff;
        }
    }
    .basicTable {
        margin-top: 10px;
        height: 300px;
    }
}
</style>